import { useMemo } from "react";
import type { BusinessSubscription, BusinessInvitation } from "lens-platform-sdk";

import { trimUUID } from "src/services/trimUUID";
import { getPlanName } from "src/services/plans";
import { getSubscriptionSeatCount } from "src/services/getSubscriptionSeatCount";

import styles from "src/components/Business/SubscriptionSelectContent.module.css";

interface Props {
  id: BusinessSubscription["id"];
  businessSubscriptions: BusinessSubscription[];
  businessInvitations: BusinessInvitation[];
}

const SubscriptionSelectOption = ({ id, businessSubscriptions, businessInvitations }: Props) => {
  const businessSubscription = useMemo(
    () => businessSubscriptions.find((subscription) => subscription.id === id),
    [id, businessSubscriptions],
  );
  const seatCount = useMemo(
    () => getSubscriptionSeatCount(businessInvitations, businessSubscription),
    [businessSubscription, businessInvitations],
  );

  if (!businessSubscription) {
    return null;
  }

  return (
    <div className={styles.selectOptionLayout}>
      <div className={styles.planNameIdWrapper}>
        <span className={styles.planName}>{getPlanName(businessSubscription.planCode)}</span>
        <span className={styles.id}>{trimUUID(id)}</span>
      </div>
      <span className={styles.availableSeats}>{seatCount.available} Seat(s) Available</span>
    </div>
  );
};

export default SubscriptionSelectOption;
